// extracted by mini-css-extract-plugin
module.exports = {"main":"Payment_main__1qRtY","paymentModeButton":"Payment_paymentModeButton__2cIqZ","cancel":"Payment_cancel__1T10b"};